/* ═══════════════════════════════════════
   BLENDIT — GSAP Animation Engine
   Emma Lewisham inspired scroll experience
   ═══════════════════════════════════════ */
(function() {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function init() {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
      setTimeout(init, 100);
      return;
    }

    gsap.registerPlugin(ScrollTrigger);

    /* ── Defaults ── */
    gsap.defaults({
      ease: 'power3.out',
      duration: 1
    });

    /* ── Scroll Progress Bar ── */
    var progressBar = document.querySelector('.scroll-progress');
    if (progressBar) {
      gsap.to(progressBar, {
        scaleX: 1,
        ease: 'none',
        scrollTrigger: {
          trigger: document.body,
          start: 'top top',
          end: 'bottom bottom',
          scrub: 0.3
        }
      });
    }

    /* ── Fade Up ── */
    gsap.utils.toArray('[data-animate="fade-up"]').forEach(function(el) {
      gsap.fromTo(el,
        { opacity: 0, y: 60 },
        {
          opacity: 1, y: 0,
          duration: 1,
          scrollTrigger: {
            trigger: el,
            start: 'top 85%',
            toggleActions: 'play none none reverse'
          }
        }
      );
    });

    /* ── Fade Left ── */
    gsap.utils.toArray('[data-animate="fade-left"]').forEach(function(el) {
      gsap.fromTo(el,
        { opacity: 0, x: -60 },
        {
          opacity: 1, x: 0,
          duration: 1,
          scrollTrigger: {
            trigger: el,
            start: 'top 85%',
            toggleActions: 'play none none reverse'
          }
        }
      );
    });

    /* ── Fade Right ── */
    gsap.utils.toArray('[data-animate="fade-right"]').forEach(function(el) {
      gsap.fromTo(el,
        { opacity: 0, x: 60 },
        {
          opacity: 1, x: 0,
          duration: 1,
          scrollTrigger: {
            trigger: el,
            start: 'top 85%',
            toggleActions: 'play none none reverse'
          }
        }
      );
    });

    /* ── Scale In ── */
    gsap.utils.toArray('[data-animate="scale"]').forEach(function(el) {
      gsap.fromTo(el,
        { opacity: 0, scale: 0.92 },
        {
          opacity: 1, scale: 1,
          duration: 1.2,
          scrollTrigger: {
            trigger: el,
            start: 'top 85%',
            toggleActions: 'play none none reverse'
          }
        }
      );
    });

    /* ── Reveal (clip-path) ── */
    gsap.utils.toArray('[data-animate="reveal"]').forEach(function(el) {
      gsap.fromTo(el,
        { clipPath: 'inset(0 0 100% 0)' },
        {
          clipPath: 'inset(0 0 0% 0)',
          opacity: 1,
          duration: 1.2,
          ease: 'power4.inOut',
          scrollTrigger: {
            trigger: el,
            start: 'top 80%',
            toggleActions: 'play none none reverse'
          }
        }
      );
    });

    /* ── Stagger Children ── */
    gsap.utils.toArray('[data-stagger]').forEach(function(parent) {
      var delay = parseFloat(parent.dataset.stagger) || 0.1;
      var children = parent.children;
      if (!children.length) return;

      gsap.fromTo(children,
        { opacity: 0, y: 40 },
        {
          opacity: 1, y: 0,
          duration: 0.8,
          stagger: delay,
          scrollTrigger: {
            trigger: parent,
            start: 'top 85%',
            toggleActions: 'play none none reverse'
          }
        }
      );
    });

    /* ── Split Text Reveal ── */
    gsap.utils.toArray('[data-split]').forEach(function(el) {
      var text = el.textContent.trim();
      var words = text.split(/\s+/);
      el.innerHTML = words.map(function(word) {
        return '<span class="word"><span class="word-inner">' + word + '</span></span> ';
      }).join('');

      var inners = el.querySelectorAll('.word-inner');
      gsap.fromTo(inners,
        { y: '100%' },
        {
          y: '0%',
          duration: 0.8,
          stagger: 0.04,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: el,
            start: 'top 85%',
            toggleActions: 'play none none reverse'
          }
        }
      );
    });

    /* ── Parallax Images ── */
    gsap.utils.toArray('[data-parallax]').forEach(function(container) {
      var speed = parseFloat(container.dataset.parallax) || 0.2;
      var img = container.querySelector('img, video');
      if (!img) return;

      gsap.fromTo(img,
        { y: -50 * speed + '%' },
        {
          y: 50 * speed + '%',
          ease: 'none',
          scrollTrigger: {
            trigger: container,
            start: 'top bottom',
            end: 'bottom top',
            scrub: true
          }
        }
      );
    });

    /* ── Image Reveal Mask ── */
    gsap.utils.toArray('.img-reveal').forEach(function(el) {
      var mask = el.querySelector('::after') || el;
      gsap.fromTo(el,
        { clipPath: 'inset(0 100% 0 0)' },
        {
          clipPath: 'inset(0 0% 0 0)',
          duration: 1.4,
          ease: 'power4.inOut',
          scrollTrigger: {
            trigger: el,
            start: 'top 80%',
            toggleActions: 'play none none none'
          }
        }
      );
    });

    /* ── Section Dividers ── */
    gsap.utils.toArray('.section-divider').forEach(function(el) {
      gsap.fromTo(el,
        { opacity: 0, scaleX: 0 },
        {
          opacity: 1, scaleX: 1,
          duration: 0.8,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: el,
            start: 'top 90%',
            toggleActions: 'play none none reverse'
          }
        }
      );
    });

    /* ── Counter Animation ── */
    gsap.utils.toArray('[data-count]').forEach(function(el) {
      var target = parseInt(el.dataset.count) || 0;
      var obj = { val: 0 };
      gsap.to(obj, {
        val: target,
        duration: 2,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: el,
          start: 'top 85%',
          toggleActions: 'play none none none'
        },
        onUpdate: function() {
          el.textContent = Math.round(obj.val).toLocaleString('es-CO');
        }
      });
    });

    /* ── Magnetic Buttons (desktop) ── */
    if (window.matchMedia('(hover: hover)').matches) {
      gsap.utils.toArray('[data-magnetic]').forEach(function(btn) {
        btn.addEventListener('mousemove', function(e) {
          var rect = btn.getBoundingClientRect();
          var x = e.clientX - rect.left - rect.width / 2;
          var y = e.clientY - rect.top - rect.height / 2;
          gsap.to(btn, { x: x * 0.3, y: y * 0.3, duration: 0.3, ease: 'power2.out' });
        });
        btn.addEventListener('mouseleave', function() {
          gsap.to(btn, { x: 0, y: 0, duration: 0.5, ease: 'elastic.out(1, 0.5)' });
        });
      });
    }

    /* ── Backward compatibility: animate old classes ── */
    gsap.utils.toArray('.blendit-animate').forEach(function(el) {
      gsap.fromTo(el,
        { opacity: 0, y: 40 },
        {
          opacity: 1, y: 0,
          duration: 1,
          scrollTrigger: {
            trigger: el,
            start: 'top 85%',
            toggleActions: 'play none none reverse'
          }
        }
      );
    });

    gsap.utils.toArray('.blendit-animate-scale').forEach(function(el) {
      gsap.fromTo(el,
        { opacity: 0, scale: 0.92 },
        {
          opacity: 1, scale: 1,
          duration: 1.2,
          scrollTrigger: {
            trigger: el,
            start: 'top 85%',
            toggleActions: 'play none none reverse'
          }
        }
      );
    });

    gsap.utils.toArray('.blendit-animate-right').forEach(function(el) {
      gsap.fromTo(el,
        { opacity: 0, x: 60 },
        {
          opacity: 1, x: 0,
          duration: 1,
          scrollTrigger: {
            trigger: el,
            start: 'top 85%',
            toggleActions: 'play none none reverse'
          }
        }
      );
    });

    gsap.utils.toArray('.blendit-animate-child').forEach(function(el) {
      var delay = parseFloat(el.style.getPropertyValue('--delay')) || 0;
      gsap.fromTo(el,
        { opacity: 0, y: 30 },
        {
          opacity: 1, y: 0,
          duration: 0.7,
          delay: delay,
          scrollTrigger: {
            trigger: el.parentElement,
            start: 'top 85%',
            toggleActions: 'play none none reverse'
          }
        }
      );
    });

    /* ── Smooth section title animations ── */
    gsap.utils.toArray('.section-title, .testimonials-title, .instagram-title, .brand-video-title').forEach(function(el) {
      gsap.fromTo(el,
        { opacity: 0, y: 20 },
        {
          opacity: 1, y: 0,
          duration: 0.8,
          scrollTrigger: {
            trigger: el,
            start: 'top 90%',
            toggleActions: 'play none none reverse'
          }
        }
      );
    });

    ScrollTrigger.refresh();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
